import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-refresh",
  "use": "icon-s-refresh-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-refresh\"><path d=\"m1 10.662 1.96.647.01.166c.245 4.258 3.772 7.592 8.028 7.592a8.05 8.05 0 0 0 5.521-2.2h-3.786V14.91h7.089V22h-1.956v-3.715a9.88 9.88 0 0 1-6.868 2.738C5.485 21.023 1 16.527 1 11zM3.933 0v3.929A10.12 10.12 0 0 1 11.046.978c5.513 0 9.998 4.495 9.998 10.022v.338l-1.96-.646-.01-.166c-.245-4.258-3.772-7.592-8.028-7.592a8.17 8.17 0 0 0-5.546 2.2h3.567v1.955h-7.09v-7.09z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol